import React from 'react'
import PropTypes from 'prop-types'
import Modal from '../leevo_ui/Modal/Modal'
import { Button } from '../ui/button'
import { AlertCircle } from 'lucide-react'

function ExitRegistrationModal({ isOpen, onClose, onConfirm }) {
  return (
    <Modal open={isOpen} onClickClose={onClose} onClickBackground={onClose}>
      <div className="py-4">
        <div className="flex items-start gap-3 mb-6">
          <div className="flex-shrink-0 w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center">
            <AlertCircle className="w-6 h-6 text-orange-600" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Exit Registration?</h3>
            <p className="text-sm text-gray-600">
              Are you sure you want to leave the registration process? Your progress will be saved, and you can return
              to complete your registration later.
            </p>
          </div>
        </div>

        <div className="flex gap-3 justify-end">
          <Button variant="outline" onClick={onClose}>
            Stay and Continue
          </Button>
          <Button variant="destructive" onClick={onConfirm}>
            Exit Registration
          </Button>
        </div>
      </div>
    </Modal>
  )
}

ExitRegistrationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
}

export default ExitRegistrationModal
